// @flow

import car1 from '../../../assets/images/base/car1.png';
import car2 from '../../../assets/images/base/car2.png';
import Page from '../../../helbest/Page/Page';
import { CardItem } from './components/CardItem/CardItem';
import { MainImage } from './components/MainImage/MainImage';
import styles from './Landing.module.css';

const items = [
  {
    image: car2,
    title: 'ابعاد و اندازه',
    desc:
      'فاصله دور محور: 2700 میلیمتر\n' +
      'ظرفیت مخزن سوخت: 48 لیتـر\n' +
      'فاصله دور محور: 2700 میلیمتر\n' +
      'ظرفیت مخزن سوخت: 48 لیتـر'
  },
  {
    image: car1,
    title: 'ابعاد و اندازه',
    desc:
      'فاصله دور محور: 2700 میلیمتر\n' +
      'ظرفیت مخزن سوخت: 48 لیتـر\n' +
      'فاصله دور محور: 2700 میلیمتر\n' +
      'ظرفیت مخزن سوخت: 48 لیتـر'
  }
];

export const Landing = () => (
  <Page logo>
    <div className={styles.LandingPage}>
      <MainImage />
      <div className={styles.CardItems}>
        {items.map((item, i) => (
          <CardItem key={i} item={item} />
        ))}
      </div>
    </div>
  </Page>
);
